import { MutableRefObject, useRef } from 'react';
import { Editor } from '@tiptap/react';

import {
  getBlockStyle,
  getFontFamily,
} from 'approot/shared/richtext/richtext.utils';
import { FONT_CALIBRE_SCHOOL } from 'approot/shared/styles/typography.style';
import { BLOCK_STYLE_PARAGRAPH } from './richtext-toolbar.constants';
import * as Styled from './richtext.style';
import { useRichTextAddAria, useToolbarJump } from './richtext.hooks';

type Props = {
  editor: Editor;
  // the toolbar's ref is passed in rather than the inner DOM element
  // so that on demand editors (e.g. table cells) have time to wire up the element before accessing code runs
  toolbarRef: MutableRefObject<HTMLDivElement | null>;
  className?: string;
  isSmall?: boolean;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
};
const Richtext = ({
  editor,
  className,
  toolbarRef,
  isSmall,
  ariaLabelledBy,
  ariaDescribedBy,
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useToolbarJump(toolbarRef);
  useRichTextAddAria({
    ariaLabelledBy,
    ariaDescribedBy,
    ref: ref.current,
  });

  return (
    <Styled.RichtextEditor
      ref={ref}
      editor={editor}
      className={className}
      $isSmall={isSmall}
      $fontFamily={
        editor
          ? getFontFamily(editor) || FONT_CALIBRE_SCHOOL
          : FONT_CALIBRE_SCHOOL
      }
      $blockStyle={
        editor
          ? getBlockStyle(editor) || BLOCK_STYLE_PARAGRAPH
          : BLOCK_STYLE_PARAGRAPH
      }
      data-selector="rich-text-editor"
    />
  );
};

export default Richtext;
